// extracted by mini-css-extract-plugin
export var errorIcon = "_lb-1";
export var nameLogo = "_lb-0";